import { createFileRoute, useParams } from "@tanstack/react-router";
import { RequisitionDetailPage } from "@/components/inventory/RequisitionDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/requisitions_/$id")({
  component: AdminRequisitionDetail,
});

function AdminRequisitionDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/requisitions_/$id" });
  return <RequisitionDetailPage reqId={id} />;
}
